// =============== LMS INTEGRATION ===============
// Unified LMS integration for SCORM and xAPI

import { initSCORM, setSCORMValue, commitSCORM, finishSCORM } from './scormRuntime';
import { initXAPI, sendAttemptedStatement, sendAnsweredStatement, sendCompletedStatement } from './xapi';

let lmsEnabled = false;
let assessmentId = null;

export function initLMS(config = {}) {
  try {
    const scormInit = initSCORM();
    const xapiInit = initXAPI(config.xapi);
    
    lmsEnabled = scormInit || xapiInit;
    assessmentId = config.assessmentId || 'extended-assessment';
    
    if (scormInit) {
      setSCORMValue('cmi.core.lesson_status', 'incomplete');
      commitSCORM();
    }
    
    if (xapiInit) {
      sendAttemptedStatement(assessmentId);
    }
    
    return lmsEnabled;
  } catch (error) {
    console.warn('LMS initialization failed:', error.message);
    return false;
  }
}

export function trackProgress(payload) {
  if (!lmsEnabled) return;
  
  try {
    const { questionId, answer, progress } = payload;
    
    setSCORMValue('cmi.core.lesson_location', questionId);
    setSCORMValue('cmi.suspend_data', JSON.stringify({ progress, lastQuestion: questionId }));
    commitSCORM();
    
    sendAnsweredStatement(questionId, answer);
  } catch (error) {
    console.warn('LMS progress tracking failed:', error.message);
  }
}

export function completeLMS(payload) {
  if (!lmsEnabled) return;
  
  try {
    const { score, status = 'completed' } = payload;
    
    setSCORMValue('cmi.core.lesson_status', status);
    setSCORMValue('cmi.core.score.raw', String(score));
    setSCORMValue('cmi.core.score.min', '0');
    setSCORMValue('cmi.core.score.max', '100');
    commitSCORM();
    finishSCORM();
    
    sendCompletedStatement(score);
  } catch (error) {
    console.warn('LMS completion failed:', error.message);
  }
}
